import { render, staticRenderFns } from "./BookableTypeChip.vue?vue&type=template&id=45294892&scoped=true&"
import script from "./BookableTypeChip.vue?vue&type=script&lang=js&"
export * from "./BookableTypeChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45294892",
  null
  
)

export default component.exports